"use client";

import { useEffect, useState } from "react";
import Cookies from "js-cookie";

export default function useAuthenticated() {
  const [hasAuthenticated, setAuthenticated] = useState(false);

  const handleAutheticatedDebug = (consent) => {
    setAuthenticated(consent);
    Cookies.set("appsignal_signed_in", consent);
  };

  useEffect(() => {
    setAuthenticated(Cookies.get("appsignal_signed_in") === "true");
  });

  return [hasAuthenticated, handleAutheticatedDebug];
}
